<template>
  <div class="memberAgreement">
    <div>河南铝粘土矿产品批发市场授权区域交易中心负责本区域会员协议的签订，对会员进行服务、管理、等级评定。</div>
    <div> 一、会员自愿进入区域交易中心市场进行矿产品及其衍生品交易，并成为区域交易中心会员，享受会员权利，履行会员义务，公平竞争，合法交易，依法纳税，诚实守信。</div>
    <div> 二、会员必须是具有市场监督和税务机关或者其他法律规定之部门认可的法人、自然人和其他组织。</div>
    <div> 三、区域交易中心是矿产品专业交易市场，按照相关法律、法规要求和公平竞争、合理流通的原则组织矿产品的交易，并受税务部门的委托代征代缴相关税收。</div>
    <div>
      四、区域交易中心运用安全、高效、便捷、先进的科技信息技术，为会员提供：1.交易服务 2.科技信息服务 3.计量服务 4.质检服务 5.税收服务 6.违约仲裁服务 7.网络货运服务 8.结算服务
      9.金融服务
      10.咨询培训及其他相关服务。
    </div>
    <div>
      五、会员在成为区域交易中心会员后方可享受会员服务。
    </div>
    <div>
      六、会员应履行以下会员义务：1.遵守国家相关法律、法规和规章制度，符合安全生产、环境保护等标准；2.遵守区域交易中心各项规则制度的规定；3.按要求供应或者收购合同约定的矿产品；4.严禁合同欺诈和不履行合同义务；5.在区域交易中心平台上提供真实的信息；6.遵守国家税收法规，诚信纳税；7.交纳交易服务费；8.变更法定代表人，名称、住所或者营业场所、经营范围及联系方式的应及时向区域交易中心报备。
    </div>
    <div>
      七、会员在成为会员后，可免费使用矿产品市场交收单（纸质交收单、矿云通卡、矿产品大数据综合服务平台使用电子交收单）。矿产品交收单是会员单位进入区域交易中心市场交易的凭证，享受会员服务。
    </div>
    <div>
      八、会员签订该协议成为会员后，即为长期会员，如无特殊情况，无需重新签订。
    </div>
    <div> 九、会员等级分为普通会员、银质会员、金质会员和钻石会员。区域交易中心按照《会员评价体系》标准综合评定会员等级。</div>
    <div> 十、会员如有出现严重的违法违纪行为或违反区域交易中心市场规则制度，区域交易中心有权单独取消会员的会员资格。</div>
    <div>
      十一、根据会员业务开展情况，经双方协商，可向区域交易中心书面申请终止会员资格。
    </div>
  </div>
</template>

<script>
export default {
  name: "memberAgreement",
  data () {
    return {
    }
  },
  created () { },
  methods: {},
}
</script>

<style scoped lang="less">
.memberAgreement {
  div {
    text-indent: 2em;
    margin-bottom: 12px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #252a37;
    letter-spacing: 0.25px;
    text-align: justify;
    line-height: 22px;
  }

  .title {
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #252a37;
    letter-spacing: 0.25px;
    text-align: justify;
    font-weight: bold;
  }

  .txt {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #252a37;
    letter-spacing: 0.25px;
    text-align: justify;
    line-height: 22px;
  }
}
</style>